import React, { useContext, useState } from 'react';
import { InputAdornment, Paper, Typography, useTheme } from '@material-ui/core';
import { Button } from '@michelin/acid-components';
import TextField from '@michelin/acid-components/build/components/TextField/TextField';
import { useTranslation } from '@michelin/central-provider';
import { WizardContext } from 'compositions/Wizard/WizardContext';
import { PQL_MOUNTING_WHEEL } from 'utils/constantValues';
import { useRequestPqlStyles } from './styles';

interface RequestPqlProps {
  readonly?: boolean;
  mobileView?: boolean;
  relatedTireMspn: string;
  setOrderWheelPQL?: (mspn: string, price: number) => void;
  onClick?: () => void;
}

export function RequestPql(props: RequestPqlProps) {
  const { readonly = false, mobileView, relatedTireMspn, setOrderWheelPQL, onClick } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const [pqlPrice, setPqlPrice] = useState<number | null>();
  const { setPql } = useContext(WizardContext);
  const wheelMspn = PQL_MOUNTING_WHEEL;

  const classes = useRequestPqlStyles(readonly, theme);

  return (
    <>
      <div className={classes.mainDiv} />
      <Paper elevation={2} className={mobileView ? classes.mobilePaper : classes.desktopPaper}>
        <Typography style={{ fontSize: 11 }}>{t('Unit price: ')}</Typography>
        <TextField
          type="number"
          placeholder={pqlPrice?.toFixed(2)}
          value={pqlPrice ? String(pqlPrice) : undefined}
          InputProps={{
            startAdornment: (
              <InputAdornment style={{ transform: 'scale(0.8)' }} position="start">
                $
              </InputAdornment>
            ),
            style: { fontSize: 12 },
          }}
          onChange={(e) => {
            const positiveValue = Number(e.target.value);
            if (positiveValue > 0) setPqlPrice(positiveValue);
            if (!positiveValue) setPqlPrice(null);
          }}
          style={{ marginLeft: 8 }}
        />
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            if (setPql && pqlPrice) {
              setPql(wheelMspn, pqlPrice, 0, relatedTireMspn);
            }
            if (setOrderWheelPQL && pqlPrice) {
              setOrderWheelPQL(wheelMspn, pqlPrice);
            }
            if (onClick) onClick();
          }}
          disabled={!pqlPrice}
          className={classes.button}
        >
          {t('Add price')}
        </Button>
      </Paper>
    </>
  );
}
